// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__iYR6r","content":"styles_content__3E_c3","module":"styles_module__TZv5l","skeleton_animate":"styles_skeleton_animate__RLfWq"};